import React from 'react'
import { modalVisibility, ModalVisibilityProps, openModal } from 'sb-modal'

import ReviewModalView from '../ReviewModalView/ReviewModalView'
import useReviewModal from './util/useReviewModal'


const ReviewModal: React.FunctionComponent<Review.ReviewModalProps & ModalVisibilityProps> = (props) => {
  const {
    product, likes, dislikes, form, isEditing, isFetching, isSubmitting,
    handleSubmit, handleRateProduct, handleClose,
  } = useReviewModal(props)

  return (
    <ReviewModalView
      product={product}
      likes={likes}
      dislikes={dislikes}
      form={form}
      isEditing={isEditing}
      isFetching={isFetching}
      isSubmitting={isSubmitting}
      onSubmit={handleSubmit}
      onRateProduct={handleRateProduct}
      onClose={handleClose}
    />
  )
}


export const openReviewModal = (props: Review.ReviewModalProps) => openModal<Review.ReviewModalProps>('review', props)


export default modalVisibility('review', ReviewModal)
